type RaceTiming = {
  raceDate?: string | Date | null
  raceTime?: string | null
  status?: string
  day?: number
}

export function getFormula1RaceStartMs(race: RaceTiming): number | null {
  if (!race.raceDate) return null
  const ymd = String(race.raceDate).slice(0, 10)
  const raw = race.raceTime || '00:00:00'
  const time = raw.length === 5 ? `${raw}:00` : raw
  const ms = Date.parse(`${ymd}T${time}`)
  return Number.isNaN(ms) ? null : ms
}

/** Next to play: not completed, and race start has not passed. */
export function isFormula1RaceUpcoming(race: RaceTiming, now = Date.now()): boolean {
  if (race.status === 'completed') return false
  const start = getFormula1RaceStartMs(race)
  if (start == null) return race.status !== 'completed'
  return start >= now
}

export function pickUpcomingFormula1Races<T extends RaceTiming>(races: T[]): T[] {
  return [...races]
    .filter((r) => isFormula1RaceUpcoming(r))
    .sort((a, b) => {
      const sa = getFormula1RaceStartMs(a)
      const sb = getFormula1RaceStartMs(b)
      if (sa != null && sb != null && sa !== sb) return sa - sb
      return (a.day ?? 999) - (b.day ?? 999)
    })
}

/** Past races: most recent first, then older. */
export function pickPastFormula1Races<T extends RaceTiming>(races: T[]): T[] {
  return [...races]
    .filter((r) => !isFormula1RaceUpcoming(r))
    .sort((a, b) => {
      const sa = getFormula1RaceStartMs(a)
      const sb = getFormula1RaceStartMs(b)
      if (sa != null && sb != null && sa !== sb) return sb - sa
      return (b.day ?? 0) - (a.day ?? 0)
    })
}
